import React from 'react';

import {linkClick} from "./../../jReact/Analytics";
import Photo from "./../Photo/Photo";
import { Article } from '../../components/Article/Article';
import "./Foot.scss";


const sign = {
  name:["", <strong>Veronika Randa</strong>],
  whatsapp:[<Ico src="whatsapp" alt="Tel."/>, <a href="tel:+420725004747" onClick={_=>linkClick("tel")}>+420 725004747</a>],
  facebook:[<Ico src="fb" alt="FB"/>, <a href="https://www.facebook.com/relaxacnidotyk/" target="_blank" rel="noopener noreferrer" onClick={_=>linkClick("fb")}>@relaxacnidotyk</a>],
  email:[<Ico src="email" alt="E-mail"/>, <a href="mailto:veronika.randa.cz@gmail.com" onClick={_=>linkClick("email")}>veronika.randa.cz@gmail.com</a>]
};


function Ico(props) {
  const {src, alt} = props;
  return <img src={"/img/ico/"+src+".svg"} className={"ico "+src} alt={alt||""} />
}

function Address(props) {
  return (
    <div className="address">
      <Photo/>
      <table>
        <tbody>
          {Object.keys(sign).map(i => {
            return <tr className={i} key={i}><td className="label">{sign[i][0]}</td><td className="value">{sign[i][1]}</td></tr>;
          })}
        </tbody>
      </table>
    </div>
  )
        
}

function Foot () {

  return (
    <footer className="Foot wall">

      <div className="block">
        <Address />
        <p className="copyright">
            Relaxační dotyk {(new Date()).getFullYear()}
        </p>
      </div>
    </footer>
  );
}

export default Foot;
